module.exports = __webpack_public_path__ + "files/e78f217c38267703d444fb8f3940a431.woff";


//////////////////
// WEBPACK FOOTER
// ./non_npm_dependencies/katex/dist/fonts/KaTeX_AMS-Regular.woff
// module id = 795
// module chunks = 60